module.exports = __webpack_public_path__ + "media/images/vp/icon.roof.black-8b8aa7dfc6dde3ad34abc51bdc25dbe7.svg";